export const sortSitesByName = (sites) =>
  // Array(...sites) to crete new array and not modify existing object
  Array(...sites).sort((siteA, siteB) => {
    const a = String(siteA.siteName).toLowerCase();
    const b = String(siteB.siteName).toLowerCase();
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
